<template>
    <div id="navbar">
        <transition name="bounce">
            <scrollactive
                    active-class="active"
                    class="header_area animated productive-nav"
                    itemscope="itemscope"
                    itemtype="http://schema.org/WPHeader"
                    :class="{ 'fixed': isScrolled && !mobile }"
                    :offset="100"
                    :duration="800"
                    bezier-easing-value=".5,0,.35,1"
            >
                <div class="container-fluid">
                    <div class="row align-items-center">
                        <div class="col-12">
                            <div class="menu_area">
                                <nav class="navbar navbar-expand-lg navbar-light" itemscope="itemscope" itemtype="http://schema.org/SiteNavigationElement">
                                    <a class="navbar-brand pointer" itemprop="url" v-scroll-to="'#hero'">
                                        <svg version="1.2" :class="{'colored':isScrolled, 'not-colored':!isScrolled || mobile}" baseProfile="tiny" id="Layer_9" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"
                                             x="0px" y="0px" width="31.333px" height="32px" viewBox="0 0 31.333 32" xml:space="preserve">
<circle fill="none" stroke="#35ADB3" stroke-width="2" stroke-miterlimit="10" cx="25.295" cy="9.006" r="3.915"/>
                                            <circle fill="none" stroke="#C73B27" stroke-width="2" stroke-miterlimit="10" cx="7.271" cy="8.452" r="4.893"/>
                                            <circle fill="none" stroke="#228642" stroke-width="2" stroke-miterlimit="10" cx="17.547" cy="24.594" r="5.383"/>
                                            <polyline fill="none" stroke="#EEB641" stroke-width="2" stroke-miterlimit="10" points="13.239,11.881 16.787,13.899
	20.151,11.881 "/>
                                            <line fill="none" stroke="#EEB641" stroke-width="2" stroke-miterlimit="10" x1="17.001" y1="17.569" x2="16.787" y2="13.899"/>
                                            <g>
</g>
                                            <g>
</g>
                                            <g>
</g>
                                            <g>
</g>
                                            <g>
</g>
                                            <g>
</g>
</svg>
                                    </a>
                                    <button
                                            v-if="!modal.show"
                                            class="navbar-toggler"
                                            type="button" data-toggle="collapse"
                                            data-target="#ca-navbar" aria-controls="ca-navbar"
                                            aria-expanded="false"
                                            aria-label="Toggle navigation"
                                            @click="onHamburgerClick"
                                    >
                                        <span class="navbar-toggler-icon"></span>
                                    </button>
                                    <div class="collapse navbar-collapse" id="ca-navbar">
                                        <ul class="navbar-nav mr-auto" id="nav" :class="{'direction-rtl': language === 'he', 'direction-ltr': language === 'en'}">
                                            <li class="nav-item">
                                                <a aria-label="about us" class="scrollactive-item nav-link" href="#opening">{{ $t('מי אנחנו') }}</a>
                                            </li>
                                            <li class="nav-item">
                                                <a aria-label="mvp program" class="scrollactive-item nav-link" style="direction: rtl" href="#mvp-offer">{{ $t('MVP מסובסד') }}</a>
                                            </li>
                                            <li class="nav-item">
                                                <a aria-label="services" class="scrollactive-item nav-link" href="#services">{{ $t('שירותים') }}</a>
                                            </li>
                                            <li class="nav-item">
                                                <a aria-label="myths-busters" class="scrollactive-item nav-link" href="#myths-busters">{{ $t('ניפוץ מיתוסים') }}</a>
                                            </li>
                                            <li class="nav-item"><a aria-label="rich-client explanation" class="scrollactive-item nav-link" href="#rich-client">SPA</a></li>
                                            <li class="nav-item"><a aria-label="development" class="scrollactive-item nav-link" href="#falafel">{{ $t('על התחום') }}</a></li>
                                            <li class="nav-item"><a aria-label="for tech" class="scrollactive-item nav-link" href="#tech">{{ $t('טכנולוגיה') }}</a></li>
                                            <li class="nav-item"><a aria-label="contact us" class="scrollactive-item nav-link" href="#contact-us">{{ $t('ליצירת קשר') }}</a></li>
                                        </ul>
                                    </div>
                                </nav>
                            </div>
                        </div>
                    </div>
                </div>
            </scrollactive>
        </transition>
    </div>
</template>

<script>
    import { mapGetters, mapActions, mapState } from 'vuex';

    export default {
        name: 'navbar',
        data() {
            return {
                isNavFixed: false,
            }
        },
        computed: {
            ...mapState('layout', {
                language: state => state.language,
            }),
            ...mapGetters({
                isScrolled: 'layout/isScrolled',
                modal: 'layout/modal',
                mobile: 'layout/mobile',

            }),
        },
        methods: {
            ...mapActions({
                updateModalTitle: 'layout/updateModalTitle',
                updateModalVisibility: 'layout/updateModalVisibility',
                updateModalContent: 'layout/updateModalContent',
                setLanguage: 'layout/setLanguage',
            }),
            changeLang() {
                this.setLanguage({
                    payload: {
                        language: this.language === 'en' ? 'he' : 'en',
                    },
                });
                this.$i18n.locale = this.language;
            },
            onHamburgerClick() {
                this.updateModalTitle({
                    payload: {
                        title: '',
                    },
                });
                this.updateModalContent({
                    payload: {
                        content: 'mobile-nav-menu',
                    },
                });
                this.updateModalVisibility({});
            },
        },
    }
</script>

<style lang="css" scoped>
    .colored circle{
        transition: all .5s ease;
    }
    .not-colored circle {
        stroke:#fff;
        transition: all .5s ease;
    }
    .colored polyline{
        transition: all .5s ease;
    }
    .not-colored polyline {
        stroke:#fff;
        transition: all .5s ease;
    }
    .colored line{
        transition: all .5s ease;
    }
    .not-colored line {
        stroke:#fff;
        transition: all .5s ease;
    }
    .slide-fade-enter-active {
        transition: all .5s ease;
    }
    .slide-fade-leave-active {
        transition: all .8s cubic-bezier(1.0, 0.5, 0.8, 1.0);
    }
    .slide-fade-enter, .slide-fade-leave-to
        /* .slide-fade-leave-active below version 2.1.8 */ {
        transform: translateX(10px);
        opacity: 0;
    }
    .header_area {
        background: transparent;
        position: fixed;
        z-index: 10000;
        top: 0;
        left: 0;
        right: 0;
        height: 56px;
        transition: background 0.5s ease;
    }
    .fixed {
        background: white;
        box-shadow: 0 10px 90px rgba(0, 0, 0, 0.08);
        transition: background 0.5s ease;
    }
    #brand-logo {
        height: 40px;
    }
    .navbar-brand {
        padding: 0;
    }
    .navbar-light .navbar-nav .nav-link {
        color: #fff;
    }
    .fixed .navbar-light .navbar-nav .nav-link {
        color: #6b696b;
    }
    .sing-up-button>a{
        color: #fff;
    }
    .fixed .sing-up-button>a{
        color: #6b696b;
    }
    .sing-up-button>a:hover{
        text-decoration: none !important;
    }
    .nav-item {
        cursor: pointer;
    }
    .active {
        font-weight: bold;
    }
    @media (max-width: 992px) {
        .header_area {
            position: absolute;
        }
    }
    .productive-nav {
        direction: rtl;
        text-align: right;
    }
    .direction-rtl {
        direction: rtl !important;
    }
    .direction-ltr {
        direction: ltr !important;
    }
</style>
